import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-select-evidencia',
  templateUrl: './select-evidencia.component.html',
  styleUrls: ['./select-evidencia.component.scss']
})
export class SelectFileComponent implements OnInit {

  @Output() public onUploadFinish = new EventEmitter<File>();
  @Input() acceptFile: string = "";
  @Input() label: string = "";

  constructor() { }

  ngOnInit() {
  }

  filesToUpload: File[] = [];

  uploadFile = (files: any) => {
    if (files.length === 0) {
      return;
    }

    if (files.length > 1) {
      // this.toastService.warning('Solo se permite un archivo', 'Carga Evidencias', {
      //   timeOut: 3000,
      // });
      this.filesToUpload = [];
      return;
    }

    if (files[0].size === 0) {
      // this.toastService.warning('El archivo seleccionado se encuentra vacio y no puede ser cargado.', 'Carga Evidencias', {
      //   timeOut: 3000,
      // });
      this.filesToUpload = [];
      return;
    }

    // this.toastService.info('Evidencia cargada con éxito', 'Carga Evidencias', {
    //     timeOut: 3000,
    //   });

    this.filesToUpload = files;
    this.onUploadFinish.emit(files[0]);
  }

}
